import React from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

const Login = ({
  onLogin,
  email,
  setEmail,
  password,
  setPassword,
  error,
  loading,
}) => (
  <div className="san-diego-alarm-program">
    <div className="sd-login-box">
      <p className="rhs-login-brand">RobinhoodSpace</p>
      <h2>False alarm permit program</h2>
      <p className="rhs-muted" style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
        Sign in to submit permits and track your program activity.
      </p>
      <p style={{ margin: '-0.5rem 0 1rem', fontSize: '0.9rem' }}>
        <Link to="/demo">Pilot demo overview →</Link>
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onLogin();
        }}
      >
        <div className="sd-form-row">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </div>
        <div className="sd-form-row">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
        <button type="submit" className="sd-login-button" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <p style={{ marginTop: '1rem' }}>
          <Link to="/signup">Sign up</Link>
        </p>
      </form>
    </div>
  </div>
);

export default Login;
